import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-

/* global dcAnalytics */

export const SuggestedAmounts = createReactClass({
    propTypes: {
        showSuggestedAmounts: PropTypes.bool.isRequired,
        handleCloseSuggestedAmounts: PropTypes.func,
        handleShowAnotherAmount: PropTypes.func,
        completionAmount: PropTypes.number,
        children: PropTypes.node.isRequired,
    },

    getDefaultProps: function () {
        return {
            showSuggestedAmounts: false,
        };
    },

    getInitialState: function () {
        return {
            showSuggestedAmounts: this.props.showSuggestedAmounts,
            showAnotherAmount: false,
        };
    },

    trackSuggestedAmount: function () {
        if (dcAnalytics) {
            dcAnalytics.trackEventGA([pageName, 'give expanded', 'suggested amount button']);
        }
    },

    trackCompletionAmount: function () {
        if (dcAnalytics) {
            dcAnalytics.trackEventGA([pageName, 'give expanded', 'complete button']);
        }
    },

    trackAnotherAmount: function () {
        if (dcAnalytics) {
            dcAnalytics.trackEventGA([pageName, 'give expanded', 'another amount link']);
        }
    },

    trackCancel: function () {
        if (dcAnalytics) {
            dcAnalytics.trackEventGA([pageName, 'give button cancel']);
        }
    },

    openAnotherAmount: function () {
        this.setState({
            showAnotherAmount: true,
        });
        this.props.handleShowAnotherAmount();
        this.trackAnotherAmount();
    },

    cancel: function () {
        this.setState({
            showSuggestedAmounts: false,
            showAnotherAmount: false,
        });
        this.props.handleCloseSuggestedAmounts();
        this.trackCancel();
    },

    getSuggestedAmounts: function () {
        var amounts = [25, 50, 100, 200];
        var returnAmounts = [];
        if (!this.props.completionAmount) {
            return amounts;
        }
        for (var i = 0; i < amounts.length; i++) {
            if (amounts[i] < this.props.completionAmount) {
                returnAmounts.push(amounts[i]);
            }
        }
        return returnAmounts;
    },

    setDonationAmountAndSubmit: function (amount) {
        var donationFormEl = this.donationFormHolder;
        if (donationFormEl && $(donationFormEl).find('form').length > 0) {
            var donationForm = $(donationFormEl).find('form')[0];
            if (donationForm.donationAmount) {
                donationForm.donationAmount.value = amount;
            } else if (donationForm.amount) {
                donationForm.amount.value = amount;
            }
            donationForm.submit();
        } else {
            alert("Woops, there was an error.  Please try entering 'another amount' instead.");
        }
    },

    submitSuggestedAmount: function (event) {
        this.setDonationAmountAndSubmit(event.currentTarget.innerHTML);
        this.trackSuggestedAmount();
    },

    submitCompletionAmount: function () {
        this.setDonationAmountAndSubmit(this.props.completionAmount);
        this.trackCompletionAmount();
    },

    render: function () {
        const hasCompletionAmount = !!(this.props.completionAmount);
        const suggestedAmountsClass = 'simple-widget-form-holder-mobile' + ((this.state.showSuggestedAmounts) ? ' on' : '');
        const anotherAmountClass = 'another-amount' + ((this.state.showAnotherAmount) ? ' on' : '');
        const anotherAmountLinkClass = 'enterAnotherAmount' + ((this.state.showAnotherAmount) ? ' on' : '');
        const suggestedAmounts = this.getSuggestedAmounts();

        return (
            <div id="donateOptions" className={suggestedAmountsClass}>
                <div className="suggestedAmountHolder">
                    <div className="anchored">
                    {
                        suggestedAmounts.map((suggestedAmount) => {
                            return <button key={'suggested-amount-' + suggestedAmount} className="button-secondary suggested-amount" onClick={this.submitSuggestedAmount}>{suggestedAmount}</button>;
                        })
                    }
                    </div>
                    <div className="complete">
                    {
                        hasCompletionAmount && (
                            <button className="button-secondary suggested-amount completeAmount" onClick={this.submitCompletionAmount}>{this.props.completionAmount}</button>
                        )
                    }
                    </div>
                    <div className="other-actions">
                        <button onClick={this.openAnotherAmount} className={`${anotherAmountLinkClass} link-button`}>Give another amount</button>
                        <button className="close text-button" onClick={this.cancel}>cancel</button>
                    </div>
                </div>

                <div ref={(e) => { this.donationFormHolder = e; }} className={anotherAmountClass}>
                    {this.props.children}
                </div>
            </div>
        );
    },
});
